export const USER_TERMS_LINK = 'https://www.auto.de/ratgeber/autokauf/qualitaetsrichtlinien-verkauf';
export const DEALER_TERMS_LINK = 'https://www.auto.de/handler-agb#Anlage1';
export const ERROR_CODE_NOT_ALLOWED = 2002;
export const ERROR_CODE_MILEAGE_TOO_BIG = 2003;
export const ERROR_CODE_VEHICLE_TOO_OLD = 2004;
export const ERROR_CODE_VEHICLE_DAMAGED = 2010;
